<template>
	<div class="cus_login_wrapper login">
		<div class="login_box">
			<div class="c_content">
				<p class="title">遊戲管理規則</p>
				<p>使用者請遵守遊戲管理規章，若違反下述所列，本公司得依所示之方式進行處理。凡暫時停權者，停權開始日起七天內未主動聯絡客服中心，將依我方查獲事實按遊戲規章辦理，使用者必須自行承擔遊戲帳號連帶之所有損失、損害與責任，以及一切道具／遊戲幣／點數使用時限等損失，本公司將不負任何賠償及退還相關費用或法律責任。
				</p><br />
				<h4>一、於進行遊戲時，若違反以下項目，將依據情節輕重給予禁言、帳號停權等不同懲罰，最重將處以永久停權，並保留一切法律追訴權。</h4>

				1.使用不當名稱或字元創設角色或盟會、軍團、公會、門派名稱。
				<br />2.於遊戲內任何公共頻道發送不當言詞，包括但不限於毀謗、散播不實內容、威脅、不雅、猥
				褻、色情、人身攻擊、性騷擾、性別歧視、挑釁、辱罵、誹謗。
				<br />3.於公開頻道發布侵犯他人個智慧財產權之內容。
				<br />4.於公開頻道或遊戲內其他可傳遞之方式，發布他人非公開之個人資訊與訊息。
				<br />5.於公開頻道發布廣告訊息。
				<br />6.販賣商品，包括但不限於遊戲幣、遊戲道具或其他非虛擬商品。
				<br />7.於公開頻道洗頻，包括但不限於以英文數字或符號等字元進行文字重複之發送，或重複且有頻
				率的多次發言，造成其他玩家無法順利正常觀看頻道之情形。
				<br />8.基於進行遊戲時彼此之間的互相尊重，禁止於遊戲公開頻道進行私人紛爭之處理或謾罵，如經
				檢舉或發現，官方得視情節輕重進行處罰。
				<br />9.散播對官方不實、未經查證的不當言論。如因此造成本公司之損害，本公司將保留一切法律追
				訴權利。
				<br />10.散播非法程式之連結、教學方式等。
				<br />11.惡意混淆玩家進行商店物品之購買。
				<br />12.惡意且不實檢舉他人。
				<br />13.惡意影響GM或客服中心、粉絲團之作業(例如：多次重覆發信、無意義之內容、或涉及不當之
				發言)。
				<br />14.意圖購買、販賣或購買、販賣遊戲幣、遊戲道具或會員帳號。
				<br />15.發現遊戲錯誤（BUG）、漏洞或其他問題時，未進行反應或使用官方提供之平台告知官方人
				員，並使用遊戲錯誤（BUG）、漏洞或其他問題進行遊戲，破壞遊戲平衡性但情節輕微者。
				<br />16.其他未在上述規範之情況，但確認已影響遊戲正常進行，或有違反遊戲公平公正合理之虞者。
				<br />17.如因使用外掛、BUG進行遊戲者，停權時間依情節輕重得超過七日。

				<br /><br />
				<h4>二、於進行遊戲時，若違反以下項目，將直接解除契約或永久停權處分，並將追究其相關法律（刑事與民事）責任。</h4>
				1.使用詐騙、盜用等非法手段取得玩家物品(例如帳號、會員資料、道具、遊戲幣)。
				<br />2.複製遊戲內之物品，及破壞、侵入、修改或破解遊戲伺服器、遊戲程式及用戶端之資料。
				<br />3.發現遊戲錯誤（BUG）、漏洞或其他問題時，未進行反應或使用官方提供之平台告知官方人員，
				並使用遊戲錯誤（BUG）、漏洞或其他問題進行遊戲，破壞遊戲平衡性且情節重大者。
				<br />4.於任何管道，包括但不限於公告頻道、私人頻道等散播遊戲錯誤（BUG）漏洞或其他問題之訊息。
				<br />5.使用外掛程式進行遊戲，外掛程式包含非官方認定任何設定或輔助程式、自動練功、軟硬體加
				速、小幫手、按鍵精靈...等，由於此類程式名稱眾多，不再逐一列出。
				<br />6.假冒官方人員進行任何行為。
				<br />7.進行任何違反當地法律之行為。

				<br /><br />
				<h4>三、違反以下項目，將暫時停權。</h4>
				1.會員資料不實，冒用他人資料。
				<br />2.合作之金流代收廠商等通知欠費鎖定。
				<br />3.主管機關來函要求鎖定配合案件處理。

				<br /><br />
				<h4>四、使用者於網站或遊戲中發生任何違反法令之行為及任何侵害他人智慧財產權之情事發生，本公司在接獲公務機關及檢調單位和司法機關或其他政府機關之命令之後，得可不經使用者同意即提供使用者之會員註冊資料及其上線時間及遊戲歷程紀錄交予相關之單位做為佐證（包括物品流向、上線IP、上線時間等等）配合調查，若前述單位要求將指名之帳號『暫時停止遊戲所有功能』，本公司有權不經使用者同意，全力配合前述單位來函之要求。</h4>
				<br />
				最新公告日期：西元2023年04月。
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CustomerContactus',
	data: function () {
		return {}
	},
}
</script>

<style lang="stylus" scoped>
@import '../../assets/styles_m/varibles.styl';

.v-enter, .v-enter-to {
  opacity: 0;
}

.v-enter-active, .v-leave-active {
  transition: opacity 1s;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(252, 197, 5, 0.06);
  -webkit-box-shadow: inset 0 0 5px rgba(252, 197, 5, 0.08);
}

::-webkit-scrollbar-thumb {
  max-height: 10px;
  border-radius: 3px;
  background: rgba(252, 197, 5, 0.8);
  -webkit-box-shadow: inset 0 0 10px rgba(252, 197, 5, 1);
}

.cus_login_wrapper {
  height: 10.6rem;
  margin: 0.29rem auto 0.4rem;
  border: 2px solid $bdColor;
  box-sizing: border-box;
  border-radius: $bdRadius;

  .login_box {
    margin: 0 auto;

    .c_content {
      overflow-y: auto;
      margin: 0 auto;
      height: 9.74rem;
      margin-top: 0.25rem;
      padding: 0 0.2rem;
      line-height: 0.4rem;
      text-align: left;
      font-size: 0.16rem;
			h4{
				font-weight: 700;
			}
      p {
        width: 100%;
        text-align: left;
        font-size: 0.16rem;
        margin-top: 0.2rem;
        margin-bottom: 0.1rem;
				text-indent: 2em;

        &.title {
          font-size: 0.18rem;
          text-align: center;
        }

        &.ind {
          text-indent: 0.25rem;
          font-weight: inherit;
        }
      }
    }

    .con {
      li {
        position: relative;
        text-align: left;
        font-size: 20px;

        &.mart {
          margin-top: 38px;
          margin-bottom: 18px;
          text-indent: 2rem;

          &::before {
            content: '';
            position: absolute;
            width: 25px;
            height: 26px;
            top: 0;
            left: 0;
            background: url('../../assets/imgs/hms-icon.png') no-repeat center;
            background-size: 300px 300px;
            background-position: -232px -155px;
          }
        }
      }
    }

    .form {
      dl {
        overflow: inherit;
      }

      .con {
        width: 290px;
      }
    }

    .login_close {
      position: absolute;
      width: 89px;
      height: 82px;
      right: 0;
      top: 0;
      border-top-right-radius: 30%;
      background: url('../../assets/imgs/close.png') no-repeat center;
      background-size: 100% 100%;
      cursor: pointer;

      i {
        display: inline-block;
        width: 31.67px;
        height: 5.65px;
        position: absolute;
        right: 9px;
        top: 18px;
        background: #ffffff;
        border-radius: 2.5px;
      }
    }

    .logo {
      display: inline-block;
      width: 460px;
      margin: 17px auto 10px;
      font-size: 26px;
      color: #4b4b4b;
      padding-bottom: 10px;
      border-bottom: 3px solid #fcc505;

      i {
        display: inline-block;
        width: 70px;
        height: 51px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -35px;
        margin-top: -25.5px;
        background: #4b4b4b;
        border-radius: 2.5px;
      }
    }

    .icon {
      span {
        display: inline-block;
        color: #545454;
        font-size: 14px;
        vertical-align: top;
        margin-right: 25px;
        margin-top: 8px;
      }

      div {
        display: inline-block;
        width: 39px;
        height: 46px;
        margin-top: 8px;
        background: url('../../assets/imgs/game-icon.png') no-repeat center;
        background-size: 500px 500px;
        cursor: pointer;

        &.gg {
          background-position: 0 -166px;
        }

        &.tw {
          background-position: -61px -166px;
        }

        &.fb {
          background-position: -123px -166px;
        }
      }
    }

    .login_reg {
      a {
        color: #2c2c2c;
        font-size: 14px;
      }
    }
  }
}
</style>
